__turbopack_context__.v({
  "check-list": "CheckList-module-scss-module__UTHlTa__check-list",
  "check-list__heading": "CheckList-module-scss-module__UTHlTa__check-list__heading",
  "check-list__icon": "CheckList-module-scss-module__UTHlTa__check-list__icon",
  "check-list__item": "CheckList-module-scss-module__UTHlTa__check-list__item",
  "check-list__items": "CheckList-module-scss-module__UTHlTa__check-list__items",
  "check-list__label": "CheckList-module-scss-module__UTHlTa__check-list__label",
});
